/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ScheduleNote/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TimegridScheduleNote from 'DesignSystem/TimegridScheduleNote/index'



/** @type {import('Simple/types.js').View} */
export default function ScheduleNote({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/SlotDialog/Content/Content/ScheduleNote",
  onClose
  
}) {
let slotDialogScheduleNoteValueData = fromData.useDataValue({ viewPath,
context: 'slot_dialog',
path: 'schedule_note',
})
  return (<React.Fragment
>
<TimegridScheduleNote
  viewPath={`${viewPath}/TimegridScheduleNote`}
 data="slot_dialog.schedule_note"
 schedule_note={slotDialogScheduleNoteValueData}
 onComplete={onClose}
/>
{children}
</React.Fragment>)
}